/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import { GoArrowLeft } from 'react-icons/go'
import { Link as RouterLink } from 'react-router-dom'
import { RETURN_PREVIEWS_PAGE } from '@/configs/strings'
import { Button, Link as ChakraLink } from '@chakra-ui/react'
import Styles from './styles.module.sass'

const ReturnButton = ({
  href,
  onClick,
  label = RETURN_PREVIEWS_PAGE
}) => {
  const iconStyle = { size: 15, color: '#000' }
  const WrapperComponent = ({ children }) => {
    return onClick
      ? <>{ children }</>
      : <ChakraLink
          as={RouterLink}
          to={href}
          className="inline-block w-full"
          style={{ textDecoration: 'none' }}
        >
          { children }
        </ChakraLink>
  }
  const buttonProps = onClick
    ? { onClick, variant: 'ghost' }
    : {}

  return (
    <WrapperComponent>
      <Button
        className={`${Styles.current} ${Styles.button} !justify-start gap-1 w-full`}
        _hover={{ bg: 'transparent' }}
        { ...buttonProps }
      >
        <GoArrowLeft
          className="basis-4 shrink-0 grow-0"
          { ...iconStyle }
        />
        <span className={Styles.label}>
        { label }
        </span>
      </Button>
  </WrapperComponent>
  )
}

export default ReturnButton
